import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { PositionEnum, SdButtonComponent } from '@seb/web-design-system/core';

import { SdAddressCardComponent } from '../address-card/address-card.component';
import { IAddressCard } from '../address-card/address-card.interface';

@Component({
  selector: 'sd-choose-addresses',
  templateUrl: './choose-addresses.component.html',
  styleUrls: ['./choose-addresses.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdAddressCardComponent, SdButtonComponent, TranslateModule]
})
export class SdChooseAddressesComponent {
  positionEnum = PositionEnum;
  selectedAddress: IAddressCard;

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel: number;

  @Input()
  title: string;

  @Input()
  savedAddressList: IAddressCard[];

  @ViewChildren('addressCardSelectable')
  addressCardSelectable: QueryList<SdAddressCardComponent>;

  @Output()
  edit = new EventEmitter<IAddressCard>();

  @Output()
  create = new EventEmitter<void>();

  @Output()
  switch = new EventEmitter<IAddressCard>();

  @Output()
  selectedAddressEvent = new EventEmitter<IAddressCard>();

  editAddress(address: IAddressCard) {
    this.edit.emit(address);
  }

  otherAddress(address: IAddressCard) {
    this.switch.emit(address);
  }

  createAddress() {
    this.create.emit();
  }

  chooseSelectedAddress() {
    this.selectedAddressEvent.emit(this.selectedAddress);
  }

  selectChange(event) {
    this.selectedAddress = event;
    this.addressCardSelectable.forEach((address) => {
      address.selected = address.address.id === event.id;
    });
  }
}
